<template>
    <el-row type="flex" justify="end">
        <el-col :lg="6" :xs="20" :sm="20" :md="8" :xl="8">
            <el-select
                    v-model="products_filter"
                    placeholder="Filter by"
                    class="filter-class"
                    @change="applyFilters"
            >
                <el-option
                        v-for="item in sorting"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                ></el-option>
            </el-select>
        </el-col>
    </el-row>
</template>

<script>

    import filter_products from "../../mixins/filter_products";

    export default {
        name: "ProductFilterComponent",
        mixins: [filter_products]
    }
</script>

<style lang="scss" scoped>
    .filter-class {
        margin: 5% 25% 5% auto;
    }
</style>
